import { DraggableAttributes, DraggableSyntheticListeners } from "@dnd-kit/core";
import { createContext, useContext } from "react";

type RowDragHandleContextValue = {
  attributes?: DraggableAttributes;
  listeners?: DraggableSyntheticListeners;
};

export const RowDragHandleContext = createContext<RowDragHandleContextValue>({});

export const useRowDragHandle = () => useContext(RowDragHandleContext);
